module.exports = __webpack_public_path__ + "static/img/09.8975c2b7.png";